import React from "react";
import { Alert, Snackbar, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { QRCodeSVG } from "qrcode.react";

const DiveSuccessSnackbar = ({
  open,
  handleClose,
  success,
  message,
  sharedDiveUrl,
  isMobile,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={sharedDiveUrl ? null : 6000} // Disable auto-hide if sharedDiveUrl exists
      onClose={handleClose}
      sx={{ maxWidth: "100%", width: isMobile ? "100%" : 500 }}
      action={
        <React.Fragment>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      }
    >
      <Alert
        onClose={handleClose}
        severity={success ? "success" : "error"}
        sx={{ width: "100%" }}
      >
        {message}
        {sharedDiveUrl && (
          <QRCodeSVG value={sharedDiveUrl} size={128} level="H" />
        )}
      </Alert>
    </Snackbar>
  );
};

export default DiveSuccessSnackbar;
